import $auth_api from "../client/auth.client";
import { AuthResponseInterface, PinResponseInterface } from "../model/auth.types";

class AuthApi {
  async login(email: string, password: string){
    try {
      const data = {
        email,
        password,
        client_id: 'okgportal'
      }
      const response = await $auth_api.post<AuthResponseInterface>('/user/login', data);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async refresh(){
    try {
      const data = {
        client_id: 'okgportal'
      }
      const response = await $auth_api.post<AuthResponseInterface>('/user/refresh-token', data);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async logout(){
    try {
      const data = { client_id: 'okgportal' }
      await $auth_api.post('/user/logout', data);
    } catch (error) {
      throw error
    }
  }

  async setupPin(pin: string){
    const response = await $auth_api.post<PinResponseInterface>('/user/pin/setup', {
      pin,
      client_id: 'okgportal'
    });
    return response.data;
  }

  async verifyPin(pin: string){
    const response = await $auth_api.post<PinResponseInterface>('/user/pin/verify', {
      pin,
      client_id: 'okgportal'
    });
    return response.data;
  }

  async resetPin(password: string, pin: string){
    const response = await $auth_api.post<PinResponseInterface>('/user/pin/reset', {
      password,
      pin,
      client_id: 'okgportal'
    });
    return response.data;
  }
}

const authApi = new AuthApi();
export default authApi;
